import {onRedirect, pageData} from "@/helpers/CypressHelper";
import RentaEasyConstants from "@/helpers/RentaEasyConstants";
import Localizer from "@/localization/Localizer";

describe('Desktop - Construction Site Equipment - Navigation tests', () => {
    before(() => {
        cy.clearAllLocalStorage()
    });

    beforeEach(() => {
        cy.useUniqueAdminSession();

        pageData().common.interceptFeatureFlags([
            {flagName: RentaEasyConstants.featureFlagConstructionSiteNewEquipmentPage, enabled: true},
            {flagName: RentaEasyConstants.featureFlagRentalReturnRequest, enabled: true},
            {flagName: RentaEasyConstants.featureFlagServicesView, enabled: true},
        ]);

        cy.intercept('POST', '/api/ConstructionSites/ProductsWithTelematics', { fixture: 'productsWithTelematics.json' });

        cy.intercept('POST', '/api/ConstructionSites/ProductWithTelematicsDetails', { fixture: 'productWithTelematicsDetails.json' })

        onRedirect(() => cy.visit(`${Localizer.pageRoutesConstructionSiteDetails}?id=20c46273-6c09-4c7d-98bf-300071dfc1e2&selectedTab=kalusto`));
    });

    it('should open product details page when click on the product name', () => {

        cy.intercept('POST', 'api/Product/GetProductAvailability', {fixture: 'productAvailability'}).as('productAvailability');

        const {new: equipment} = pageData().constructionSite.equipment;

        equipment.grid().should('exist');
        equipment.accordionButton(0).click();
        equipment.productGroup().find('a').click();

        cy.waitSuccess('@productAvailability');

        cy.url().should('include', Localizer.pageRoutesProductDetails);
        cy.url().should('include', `konenostaja-500`);
    });

    it('should open category page when click on the category name', () => {

        cy.intercept('POST', '/api/Product/ProductDepotAvailability').as('productDepotAvailability');

        const {new: equipment} = pageData().constructionSite.equipment;

        equipment.grid().should('exist');
        equipment.accordionButton(0).click();
        equipment.category().find('a').click();

        cy.waitSuccess('@productDepotAvailability');

        cy.url().should('include', `${Localizer.pageRoutesRent}`);
        cy.url().should('include', `konenostimet`);
    });

    it('should neither open product details page nor device details page when click on unknown name', () => {

        const response = {
            "value": {
                "rentaId": "42343",
                "rentalInformation": {},
                "returnRequests": [],
                "rentalContracts" : [],
                "isMassProduct": false,
                "localizedCategoryName": null,
                "localizedProductName": null,
                "url": "betongborr-14-0-mm"
            },
            "context": null,
            "newVersionAvailable": false,
            "redirect": null,
            "error": null,
            "alert": null,
            "unauthorized": false,
            "isResponseContainer": true
        };

        cy.intercept('POST', '/api/ConstructionSites/ProductWithTelematicsDetails', { statusCode: 200, body: response });

        const {new: equipment} = pageData().constructionSite.equipment;

        equipment.grid().should('exist');
        equipment.accordionButton(0).click();

        cy.location('pathname').then((initialPath) => {
            equipment.category().click();

            // Assert that the URL has not changed after the click.
            cy.location('pathname').should('eq', initialPath);
        });
    });

    it('should open device details page when click on view more link', () => {

        const response = {
            "value": {
                "rentaId": "42343",
                "rentalInformation": {},
                "returnRequests": [],
                "rentalContracts" : [],
                "isRented": true,
                "isMassProduct": false,
                "localizedCategoryName": null,
                "localizedProductName": null,
                "url": "betongborr-14-0-mm"
            },
            "context": null,
            "newVersionAvailable": false,
            "redirect": null,
            "error": null,
            "alert": null,
            "unauthorized": false,
            "isResponseContainer": true
        };

        cy.intercept('POST', '/api/ConstructionSites/ProductWithTelematicsDetails', { statusCode: 200, body: response });

        cy.intercept('POST', '/api/Fleet/GetDeviceExtendedDetails', { fixture: 'getDeviceExtendedDetails.json' });

        cy.intercept('POST', '/api/Product/GetMachineDocuments', { fixture: 'machineDocumentsData.json' });

        cy.intercept('POST', '/api/Locations/GetDeviceUsage', { fixture: 'getDeviceUsage.json' });

        const {new: equipment} = pageData().constructionSite.equipment;

        equipment.grid().should('exist');
        equipment.accordionButton(0).click();
        equipment.moreInfo().first().click();

        cy.url().should('include', Localizer.pageRoutesDeviceDetailsPage);
        cy.url().should('include', `rentaId=42343`);
    });

    it('should open product details page when click on view more link', () => {

        const response = {
            "value": {
                "rentaId": null,
                "rentalInformation": {},
                "returnRequests": [],
                "rentalContracts" : [],
                "isRented": true,
                "isMassProduct": true,
                "localizedCategoryName": {
                    "name": "Konenostimet",
                    "url": "konenostimet"
                },
                "localizedProductName": {
                    "name": "Konenostaja 500",
                    "url": "konenostaja-500"
                },
                "url": "konenostaja-500"
            },
            "context": null,
            "newVersionAvailable": false,
            "redirect": null,
            "error": null,
            "alert": null,
            "unauthorized": false,
            "isResponseContainer": true
        };

        cy.intercept('POST', '/api/ConstructionSites/ProductWithTelematicsDetails', { statusCode: 200, body: response });

        cy.intercept('POST', 'api/Product/GetProductAvailability', {fixture: 'productAvailability'}).as('productAvailability');

        const {new: equipment} = pageData().constructionSite.equipment;

        equipment.grid().should('exist');
        equipment.accordionButton(0).click();
        equipment.moreInfo().first().click();

        cy.waitSuccess('@productAvailability');

        cy.url().should('include', Localizer.pageRoutesProductDetails);
        cy.url().should('include', `konenostaja-500`);
    });

    it('should open return page when click on view more link', () => {

        const {new: equipment} = pageData().constructionSite.equipment;

        equipment.grid().should('exist');
        equipment.accordionButton(0).click();
        equipment.moreInfo().last().click();

        cy.url().should('include', `${Localizer.pageRoutesAdminReturnDetails}`);
        cy.url().should('include', '75362194-4dda-45ee-a6f4-7375c25df05f');
    });
});